import { MouseEventHandler, ReactNode, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";

import { ReactComponent as CheckboxBorder } from "../../assets/checkbox-border.svg";
import { ReactComponent as Check } from "../../assets/check.svg";
import { ReactComponent as Remove } from "../../assets/remove.svg";
import { ConnFeatureFilter, FeatureClauses, FilterTypes } from "../../types/CDIFilter";

interface FilterItemProps {
	name: string;
	defaultMessage: string;
	icon: ReactNode;
	label: string;
	value: FeatureClauses;
	filterType: FilterTypes;
	onChange: (filter: ConnFeatureFilter, filterType: FilterTypes) => void;
	handleSetOnlyFilter?: MouseEventHandler<HTMLDivElement>;
	filters?: ConnFeatureFilter[];
}

const FilterItem = ({
	name,
	defaultMessage,
	icon,
	label,
	value,
	filterType, // NEW
	onChange,
	handleSetOnlyFilter,
	filters,
}: FilterItemProps) => {
	const [filter, setFilter] = useState<ConnFeatureFilter>({
		feature: label,
		clause: value,
	});
	const [active, setActive] = useState(false);
	
	useEffect(() => {
		setFilter({
			feature: label,
			clause: value,
		});
		
		if (filters) {
			const isActive = filters.every(
				(filter) =>
					(filter.clause === FeatureClauses.MustNot &&
						filter.feature !== label) ||
					(filter.feature === label && filter.clause === FeatureClauses.Must),
			);
			setActive(isActive);
		}
	}, [value, label, filters]);
	
	const handleCheckboxChange = () => {
		let newClause: FeatureClauses;
		
		if (filter.clause === FeatureClauses.None) {
			newClause = FeatureClauses.Must;
		} else if (filter.clause === FeatureClauses.Must) {
			newClause = FeatureClauses.MustNot;
		} else {
			newClause = FeatureClauses.None;
		}
		
		const newFilter: ConnFeatureFilter = {
			feature: label,
			clause: newClause,
		};
		
		setFilter(newFilter);
		
		onChange(newFilter, filterType);
	};
	
	const renderCheckboxIcon = () => {
		if (filter.clause === FeatureClauses.Must) {
			return <Check style={{ position: "absolute" }} />;
		} else if (filter.clause === FeatureClauses.MustNot) {
			return <Remove style={{ position: "absolute", color: "black" }} />;
		} else {
			return null;
		}
	};
	
	return (
		<div className="filter-item">
			<label className="filter-item-icon-with-label">
				<div className="icon-wrapper">{icon}</div>
				<FormattedMessage id={name} defaultMessage={defaultMessage} />
			</label>
			
			<div
				className={`filter-item-only ${
					active ? "filter-item-only-active" : ""
				}`}
				onClick={handleSetOnlyFilter}
			>
				<FormattedMessage id="Only" defaultMessage="only" />
			</div>
			
			<div className="filter-item-checkbox" onClick={handleCheckboxChange}>
				<CheckboxBorder />
				{renderCheckboxIcon()}
			</div>
		</div>
	);
};

export default FilterItem;